import { useEffect, useState } from 'react';
import { GlobeIcon } from 'zudoku/icons';

import { LANGUAGES, PAGE_LANGUAGE, applyLanguage, currentLanguage, isLanguage, mountTranslate, type LanguageCode } from './translate';

/**
 * Header language switch: Google's free website translator (no API key), the
 * docs being written in French. Rendered `notranslate` so the menu itself keeps
 * each language's own name.
 */
export const LanguagePicker = () => {
  const [lang, setLang] = useState<LanguageCode>(PAGE_LANGUAGE);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    mountTranslate();
    setLang(currentLanguage());
  }, []);

  return (
    <label
      className="notranslate noe-lang-picker relative inline-flex items-center gap-1.5 rounded-full border border-border px-3 h-9 text-sm text-foreground hover:bg-accent focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary"
      translate="no"
      title="Traduire cette page"
    >
      <GlobeIcon size={15} strokeWidth={2} aria-hidden="true" />
      <span className="sr-only">Langue de la page</span>
      <select
        className="appearance-none bg-transparent pr-1 outline-none cursor-pointer disabled:opacity-60"
        value={lang}
        disabled={busy}
        onChange={(event) => {
          const next = event.target.value;
          if (!isLanguage(next)) return;
          setLang(next);
          setBusy(true);
          void applyLanguage(next).finally(() => setBusy(false));
        }}
      >
        {LANGUAGES.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag} {language.label}
          </option>
        ))}
      </select>
    </label>
  );
};
